import { Button, ReportPreview } from "@mcleod/components";
import { AutogenLayoutDataFusionInvoicesTransferSlideout } from "./autogen/AutogenLayoutDataFusionInvoicesTransferSlideout";
import { Api, Currency, DateRange } from "@mcleod/core";
import { CommonDialogs } from "@mcleod/common";
import { DataFusionInvoicesFromBillingHistory } from "./DataFusionInvoicesFromBillingHistory";

export class DataFusionInvoicesTransferSlideout extends AutogenLayoutDataFusionInvoicesTransferSlideout {

    private reportPreviewPostStep: ReportPreview;
    private _selectedInvoiceIds: string[];
    private _buttonNextStep: Button;
    private _selectedCheckAmountSum: Currency;
    private _selectedRowCount: number;
    private _postingCallback: () => void;
    private _dateRange: DateRange;
    public parentBillingHistory?: DataFusionInvoicesFromBillingHistory;

    override onLoad() {
        this.createPostStepReportPreview();
    }

    get dateRange(): DateRange {
        return this._dateRange
    }

    set dateRange(range: DateRange) {
        this._dateRange = range;
    }

    get selectedInvoiceIds(): string[] {
        return this._selectedInvoiceIds;
    }

    set selectedInvoiceIds(value: string[]) {
        this._selectedInvoiceIds = value;
    }

    get buttonNextStep(): Button {
        return this._buttonNextStep;
    }

    set buttonNextStep(value: Button) {
        this._buttonNextStep = value;
    }

    get selectedCheckAmountSum(): Currency {
        return this._selectedCheckAmountSum;
    }

    set selectedCheckAmountSum(value: Currency) {
        this._selectedCheckAmountSum = value;
    }

        get selectedRowCount(): number {
        return this._selectedRowCount;
    }

    set selectedRowCount(value: number) {
        this._selectedRowCount = value;
    }

    get postingCallback(): () => void {
        return this._postingCallback;
    }

    set postingCallback(value: () => void) {
        this._postingCallback = value;
    }

    private createPostStepReportPreview() {
        this.reportPreviewPostStep = new ReportPreview(
            { reportPreviewTitle: "" },
            { id: "reportPreviewPostStep" }
        );
    // Remove left-side tab navigation when only a single report is returned
    // (ReportPreview defaults displaySingleResultInTabset to true, which forces a Tabset even for one tab.)
    this.reportPreviewPostStep.displaySingleResultInTabset = false;
    this.layoutTransferSlideout.add(this.reportPreviewPostStep);
    }

    /**
     * Sends a request to post the invoice transactions for the selected invoice IDs.
     * Updates the stepper to the post step and displays the posting report.
     */
    public async postInvoiceTransactions(): Promise<void> {
         if (await this.getPostingConfirmation()) {
            this.reportPreviewPostStep.beginSearch();
            const response = await Api.post("lme/datafusion/post-invoices", {
                unposted_invoice_ids: this.selectedInvoiceIds,
                date_range_start: this.dateRange.startDate,
                date_range_end: this.dateRange.endDate
            });
            //this flag is updated to prevent the parent component from refreshing of search data during the transfer process
            if (this.parentBillingHistory) {
                this.parentBillingHistory.isTransferring = true;
            }
            const responseFirstRow = response?.data?.[0];
            this.reportPreviewPostStep.endSearch(responseFirstRow?.reports);
            if (this.postingCallback) {
                this.postingCallback();
            }
        } else {
            await this.slideOut();
        }
    }

    private async getPostingConfirmation(): Promise<boolean> {
        const count = this._selectedRowCount || 0;
        const total = this._selectedCheckAmountSum || new Currency(0);
        if (count > 0) {
            return await CommonDialogs.showYesNo(`${count} transactions totaling ${total.symbol}${total.amount} will be transferred.`, "Transfer Invoices");
        } else {
            await CommonDialogs.showMessage("No transactions to transfer.", "Transfer Invoices");
            return false;
        }
    }
}
